import { makeStyles } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import { useEffect, useState } from "react";
import { Label } from "reactstrap";
import CustomImageUploader from "./CustomImageUploader";
import MDBox from "./MDBox";

const CustomDrawer = ({
  fetchSlide,
  lang,
  slide_id,
  data,
  open,
  toggleDrawer,
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(data?.files?.[0]?.url);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // const extractedTitle = data?.pinLocalizations?.filter((e) => e.field === "title");
    // const extractedBody = data?.pinLocalizations?.filter((e) => e.field === "body");
    setTitle(data?.title);
    setDescription(data?.body);
  }, [data]);


  const classes = useStyles();

  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={() => toggleDrawer(false)}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.list}>
        <MDBox component="form" role="form">
          <MDBox mt={5} mb={2}>
            <Label value={title} type="text" label="Title" fullWidth />
          </MDBox>
          <MDBox mb={2}>
            <Label
              value={description}
              type="text"
              label="Description"
              fullWidth
            />
          </MDBox>
        </MDBox>
        <CustomImageUploader
          value={image}
          files={data?.files}
          setImage={setImage}
        />
      </div>
    </Drawer>
  );
};

export default CustomDrawer;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "300px",
    flexShrink: 0,
  },
  drawerPaper: {
    width: "300px",
    backgroundColor: "#f5f5f5",
    marginHorizontal: 20,
  },
  toolbar: theme.mixins.toolbar,
  list: {
    margin: "0 20px",
  },
}));
